<template>
  <div class="contract-information-page pb60" v-loading.fullscreen.lock="fullscreenLoading">
    <Title currentPageTitle="质量考核审批申请"></Title>
    <!-- 质量考核审批申请 -->
    <div class="contract-base-box">
      <p class="contract-base-name">基础信息</p>
      <el-row :gutter="24">
        <el-col :span="6" >
          <div class="contract-base-title" style="width: 135px;"><span class="fontC-red">*</span>是否平台专属任务：</div>
          <el-select 
            :disabled="isEdit" 
            size="mini" 
            filterable  
            v-model="formData.taskBelongCategory" 
            class="ipt-sty" 
            placeholder="请选择"
            @change="taskBelongCategoryChange"
          >
            <el-option v-for="item in categoryList"
              :key="item.value"
              :label="item.text"
              :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <div v-if="formData.taskBelongCategory==2">
          <el-col :span="8">
          <div class="contract-base-title"><span class="fontC-red">*</span>所属企业：</div>
          <el-select
            :disabled="isEdit"
            size="small"
            v-model="formData.tenantGuid"
            placeholder="请选择企业"
            class="ipt-sty"
            @change="tenantChange"
            filterable
          >
            <el-option
              v-for="item in serviceTenantList"
              :key="item.guid" 
              :label="item.tenantName"
              :value="item.guid"
            >
            </el-option>
          </el-select>
        </el-col>
        </div>
        <div v-else>
          <el-col :span="6">
          <div class="contract-base-title"><span class="fontC-red">*</span>备案企业：</div>
          <el-select
            :disabled="isEdit"
            size="small"
            v-model="formData.tenantGuid"
            placeholder="请选择备案企业"
            class="ipt-sty"
            @change="tenantChange"
            filterable
          >
            <el-option
              v-for="item in tenantList"
              :key="item.sendTenantGuid"
              :label="item.sendTenantName"
              :value="item.sendTenantGuid"
            >
            </el-option>
          </el-select>
          </el-col>
          <el-col :span="6" >
          <div class="contract-base-title"><span class="fontC-red">*</span>组织名称：</div>
          <el-select
            :disabled="isEdit"
            size="small"
            v-model="formData.organisationGuid"
            placeholder="请选择组织"
            class="ipt-sty"
            filterable
            @change="changeOrganisation"
          >
            <el-option v-for="item in organisationList" :key="item.value" :label="item.text" :value="item.value">
            </el-option>
          </el-select>
          </el-col>
          <el-col :span="6" >
            <div class="contract-base-title"><span class="fontC-red">*</span>核算月：</div>
            <el-date-picker
              :disabled="isEdit"
              size="small"
              v-model="formData.accountMonth"
              class="ipt-sty"
              value-format="yyyy-MM"
              type="month"
              placeholder="请选择核算月"
              @change="changeAccountMonth"
            >
            </el-date-picker>
          </el-col>
        </div>
        
        <!-- <el-col :span="4">
          <div class="contract-base-title"><span class="fontC-red">*</span>任务包选择：
          </div>
          <el-select
            :disabled="isEdit"
            size="small"
            v-model="formData.isPrecise"
            placeholder="请选择"
            filterable
            @change="changePrecise"
          >
            <el-option v-for="item in isOption" :key="item.value" :label="item.text" :value="item.value"> </el-option>
          </el-select>
        </el-col> -->
        <!-- <el-col :span="7" v-show="formData.isPrecise == 'Y'">
          <div class="contract-base-title"><span class="fontC-red"> </span>账单周期：</div>
          <el-select size="small" :disabled="isEdit" v-model="formData.billCycle" placeholder="请选择" class="ipt-sty" filterable>
            <el-option v-for="item in billCycleList" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="20" v-if="formData.isPrecise == 'N'">
          <el-popover placement="top-start" content="该任务包如有业务员已结算，重新选择该任务包时，这批业务员无法查询。" trigger="hover">
            <div class="contract-base-title" slot="reference"><span class="fontC-red">*</span>任务包标题：</div>
          </el-popover>
          <el-select
            :disabled="isEdit"
            size="small"
            v-model="formData.taskGuidList"
            placeholder="请选择"
            class="ipt-sty"
            filterable
            multiple
          >
            <el-option v-for="item in taskList" :key="item.guid" :label="item.taskTitle" :value="item.guid">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="7" v-show="formData.isPrecise == 'N'">
          <div class="contract-base-title"><span class="fontC-red"> </span>账单周期：</div>
          <el-select size="small" :disabled="isEdit" v-model="billCycleListSelect" placeholder="请选择" class="ipt-sty" filterable multiple collapse-tags>
            <el-option v-for="item in billCycleOption" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-col> -->
        </el-row>
        <el-row>
        <el-col :span="12">
          <div  class="contract-base-flow">
            <div class="contract-base-title" style="width: 108px;"><span class="fontC-red">*</span>关联运营报告：</div>
            <el-input :disabled="isEdit" v-model="formData.relevance" placeholder="请选择关联运营报告" readonly
              @focus="focusRelevance">
            </el-input>
          </div>
        </el-col>
        <el-col :span="6" style="padding: 0 12px;">
          <div class="contract-base-title"><span class="fontC-red"></span>账单周期：</div>
          <!-- <div class="ipt-sty" style="line-height: 36px;">{{ billCycle }}</div> -->
          <el-input readonly v-model="billCycle" >
          </el-input>
        </el-col>
        <el-col :span="6" v-if="!isEdit" class="search-btn">
          <el-button size="small" type="info" @click="searchData()">搜索</el-button>
          <el-button size="small" type="danger" @click="emptyData()">清空</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="back-color-fff">
      <TabList :tabList="tabList" :tabIndex="tabIndex" @tabChange="tabChange" marginTop="0px"></TabList>
    </div>
    <div class="back-color-fff content-main-box h100f" style="padding: 0 16px" v-show="currentTabIndex == 0">
      <div style="display:flex;justify-content: space-between;align-items: center;">
        <div class="btn-import">
          <div style="display:flex">
            <el-upload
              class="upload-demo t-left"
              action="#"
              multiple
              :limit="1"
              accept=".xlsx,.xsl,.xls,.xlsm"
              :before-upload="beforeUpload"
              :http-request="changeFile"
              :file-list="fileList"
              :show-file-list="false"
            >
              <el-button size="mini" class="mr10" type="info" icon="el-icon-plus">导入</el-button>
            </el-upload>
            <el-button size="mini"  type="borderGreen" @click="exportTable(1)">导出</el-button>
            <el-button size="mini" v-if="formData.approveState == 'N' || formData.approveState == 'Y'" type="borderGreen" @click="recalculate(1)">重算任务大类</el-button>
          </div>

        </div>
        <p class="total-tip">平台考核后金额合计：<span>{{ getSumAmount(formData.detailList, 1) | numDigit }}</span>元&nbsp;&nbsp;&nbsp;应发金额合计：<span>{{ getSumAmount(formData.detailList, 2) | numDigit }}</span> 元&nbsp;&nbsp;&nbsp;实发金额合计：<span>{{ getSumAmount(formData.detailList, 4) | numDigit }}</span> 元&nbsp;&nbsp;&nbsp;任务完成金额合计：<span>{{ getSumAmount(formData.detailList, 3) | numDigit }}</span> 元</p>
      </div>
      <el-table :data="formData.detailList" @selection-change="handleSelectionChange" style="width: 100%" :height="formData.detailList.length>=10?500:''" ref="tableOne">
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column label="序号" width="60" header-align="center" align="center" fixed="left">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
            <!-- {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }} -->
          </template>
        </el-table-column>
        <el-table-column
          prop="staffName"
          label="姓名"
          show-overflow-tooltip
          header-align="center"
          align="left"
          fixed="left"
          width="96"
        >
          <template slot-scope="scope">{{ scope.row.staffName || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="organisationName"
          label="平台组织名称"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="140"
        >
          <template slot-scope="scope">{{ scope.row.organisationName || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="positionList"
          label="平台岗位名称"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="140"
        >
          <template slot-scope="scope">{{ scope.row.positionList || '-' }}</template>
        </el-table-column>
        <el-table-column
          v-for="(item, index) in fieldData"
          :key="index"
          :prop="item.fieldName"
          :label="item.title"
          show-overflow-tooltip
          header-align="center"
          align="right"
          width="140"
        >
          <template slot-scope="scope">
            <span v-if="item.type == 'score'">{{ Number(scope.row[item.fieldName]).toFixed(6) }}</span>
            <span v-if="item.type == 'amount' && item.fieldName !== 'cutTotalMoney'">{{scope.row[item.fieldName] | numDigit }}</span>
            <span v-if="item.type == 'amount' && item.fieldName == 'cutTotalMoney'">{{ scope.row[item.fieldName] | numDigit }}</span>
            <span v-if="item.type == 'text'">{{scope.row[item.fieldName] || '-' }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          v-if="item.type == 'num'"
          v-for="(item, index) in fieldData"
          :key="index"
          :prop="item.fieldName"
          :label="item.title"
          show-overflow-tooltip
          header-align="center"
          align="right"
          width="110"
        >
          <template slot-scope="scope">
            <el-input
              v-model="scope.row[item.fieldName]"
              oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{6,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
              maxlength="12"
              placeholder="请输入"
            ></el-input>
          </template>
        </el-table-column> -->
      </el-table>
    </div>
    <!-- 任务完成明细 -->
    <div class="back-color-fff content-main-box h100f"  style="padding: 0 16px" v-show="currentTabIndex == 1">
      <div class="button-area fl pr0" >
        <el-button  size="mini" type="borderGreen" @click="exportTableTwo(2)">导出</el-button>
      </div>
      <el-table :data="tableTwoList" stripe border row-key="guid" default-expand-all :tree-props="{children: 'taskDetailList'}"   ref="tableTwo" header-cell-class-name="table_header">
        <el-table-column
          prop="staffName"
          label="推广服务人员"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="120"
        >
          <template slot-scope="scope">{{ scope.row.staffName || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="taskContentName"
          label="任务内容"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="120"
        >
          <template slot-scope="scope">{{ scope.row.taskContentName || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="rate"
          label="占比(%)"
          show-overflow-tooltip
          header-align="center"
          align="right"
          width="100"
        >
          <template slot-scope="scope">{{ scope.row.rate || '-' }}</template>
        </el-table-column>
        <el-table-column
          sortable
          prop="taskMoney"
          label="实际完成金额(元)"
          show-overflow-tooltip
          header-align="center"
          align="right"
          width="160"
        >
          <template slot-scope="scope">{{ scope.row.taskMoney | numDigit }}</template>
        </el-table-column>
        <el-table-column
          sortable
          prop="realMoney"
          label="结算金额(元)"
          show-overflow-tooltip
          header-align="center"
          align="right"
          width="160"
        >
          <template slot-scope="scope">{{ scope.row.realMoney  | numDigit }}</template>
        </el-table-column>
        <el-table-column
          sortable
          prop="isOverMoney"
          label="是否超额结算"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="120"
        >
          <template slot-scope="scope">{{ scope.row.isOverMoney || '-' }}</template>
        </el-table-column>
      </el-table>
      <!-- 简述备注 -->
      <div v-show="currentTabIndex == 1" class="remark">
        <p style="text-align: left">{{'简述或备注'}}</p>
        <el-input 
          type="textarea" 
          :rows="2"
          v-model="formData.remark" 
          placeholder="请输入, 限制100个字" 
          maxlength="100" 
          show-word-limit
          clearable>
        </el-input>
      </div>
    </div>
    <!-- 流程 -->
    <div style="padding-left: 16px; background: #fff; margin-top: 4px">
      <iframe v-show="iframeSh" :src="srcs" class="iframe-sty"></iframe>
    </div>
    <!-- 提交 -->
    <div class="submit_btn_wrap">
      <el-button type="borderBlack" size="small" @click="$router.go(-1)">取消</el-button>
      <el-button type="borderGreen" size="small" @click="submitData(0)">保存</el-button>
      <el-button type="importNew" size="small" @click="submitData(1)">提交申请</el-button>
    </div>
    <!-- 导入 -->
    <el-dialog
      title="批量导入"
      :visible.sync="showImport"
      width="800px"
      class="importClass"
      :close-on-click-modal="false"
    >
      <div class="secondStep">
        <p class="line1" v-if="importResult.error == '0'">数据导入完成，请核对！</p>
        <p class="line1" v-else>数据导入完成，请核对！</p>
        <p class="line2">
          共导入数据 <span> {{ importResult.total }} </span> 条，导入成功 <span>{{ importResult.ok }} </span> 条
          <span v-if="importResult.error > 0"
            >，失败<span> {{ importResult.error }} </span> 条。</span
          >
        </p>
        <p class="line3" @click="downFailData" v-if="importResult.error > 0">下载导入失败数据</p>
      </div>
    </el-dialog>
    <!-- start of dialog-关联流程 -->
    <el-dialog title="运营报告" class="flow-dialog" :visible.sync="dialogFormVisible" width="80%">
      <div class="content-main-box content-main-box2">
        <div class="search-area">
            <el-row :gutter="24">
                <el-col :span="8">
                    <div class="search-area-div w80">关键字搜索</div>
                    <el-input v-model="operationPage.searchKey" placeholder="请输入企业、组织、应付金额搜索" size="mini" class="ipt-sty">
                    </el-input>
                </el-col>
                <!-- <el-col :span="8">
                    <div class="search-area-div w60">关联状态</div>
                    <el-select filterable clearable v-model="operationPage.isUsedQuality" placeholder="请选择关联状态"
                        size="mini" class="ipt-sty">
                        <el-option
                          v-for="item in isUsedOption"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                    </el-select>
                </el-col> -->
                <el-col :span="8" class="search-btn-box">
                    <el-button size="mini" type="info" @click="getOperationList(1)">搜索</el-button>
                    <el-button size="mini" type="danger" @click="emptyOperationSearch">清空</el-button>
                </el-col>
            </el-row>
        </div>

        <el-table stripe border ref="multipleTable1" highlight-current-row :data="operationTableData"
            :row-key="(row) => row.guid" :current-row-key="currentRowKey" @row-click="flowListsChange"
            @select="handleSelectFlow" :header-cell-class-name="cellClass">
            <el-table-column type="selection" :reserve-selection="true" :show-header="false"> </el-table-column>
            <!-- 流程名称 -->
            <el-table-column prop="flowName" min-width="120" label="流程名称" header-align="center" align="left" show-overflow-tooltip>
            </el-table-column>
            <!-- 发起人 -->
            <el-table-column prop="staffName" label="发起人" header-align="center" align="left" show-overflow-tooltip>
            </el-table-column>
            <!-- 药企名称 -->
            <el-table-column prop="bizTenantName" label="药企名称" header-align="center" align="left"
                show-overflow-tooltip>
            </el-table-column>
            <!-- 组织名称 -->
            <el-table-column prop="organisationName" label="组织名称" header-align="center" align="left"
                show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ scope.row.bizOrganisationName || '-' }}
                </template>
            </el-table-column>
            <!-- 核算月 -->
            <el-table-column prop="accountMonthName" min-width="96" label="核算月" header-align="center" align="left"
                show-overflow-tooltip>
            </el-table-column>
            <!-- 账单周期 -->
            <el-table-column prop="billCycleList" label="账单周期" header-align="center" align="left"
                show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ scope.row.billCycleList|billFilter }}
                </template>
            </el-table-column>
            <!-- 任务包名称 -->
            <el-table-column prop="taskTitleName" min-width="120" label="任务包名称" header-align="center" align="left"
                show-overflow-tooltip>
            </el-table-column>
            <!-- 应付金额 -->
            <el-table-column prop="currentPayAmount" min-width="96" label="应付金额(元)" header-align="center"
                align="right" show-overflow-tooltip>
                <template slot-scope="scope">{{ scope.row.currentPayAmount | numFmt | numDigit }}</template>
            </el-table-column>
        </el-table>

        <!-- start of pagination -->
        <!-- <el-pagination
            class="pt pb back-color-fff"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[10, 20, 50, 100]"
            :current-page="page.pageIndex"
            :page-size="page.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="page.totalRows"
        >
        </el-pagination> -->
        <!-- end of pagination -->
      </div>
      <div slot="footer">
          <el-button plain size="mini" @click="dialogFormVisible = false">取消</el-button>
          <el-button size="mini" type="info" @click="selectProcess()">确定</el-button>
      </div>
    </el-dialog>
        <!-- end of dialog-关联流程 -->
  </div>
</template>
<script>
import { bpmnroute } from '@/api/apiRoute';
import areaJson from '../../assets/js/china_address_v4.js';
import Title from '@/components/title/title.vue';
import TabList from '@/components/tab/tabList.vue';
import { values } from 'lodash';
import getTenantDetail from '../mixins/getTenantDetail';
import { ServiceProviderTypeEnum } from '../mixins/getTenantDetail'
export default {
  components: {
    Title,
    TabList,
  },
  mixins:[getTenantDetail],
  data() {
    return {
      ServiceProviderTypeEnum,
      serviceTenantList:[],
      selectData: [],
      height: window.innerHeight - 400,
      flowType: '00020',
      tabList: [{ tabName: '考核一览表' }, { tabName: '任务完成明细' }],
      categoryList: [
        { text: '是', value: 2 },
        { text: '否', value: 1 },
      ],
      currentTabIndex: 0, //当前tab
      tabIndex: 0,
      fullscreenLoading: false,
      dialogVisible: false,
      dialogVisibleSelect: false,
      dialogFormVisible: false,// 关联流程相关
      tenantList: [],
      organisationList: [],
      fileList: [],
      taskList: [],
      tableTwoList:[],
      salesTerritoryList: [],
      // billCycleList: [],
      // billCycleOption: ['一期', '二期', '三期', '四期', '五期', '六期', '七期', '八期', '九期', '十期', '十一期', '十二期', '十三期', '十四期', '十五期', '十六期', '十七期', '十八期', '十九期', '二十期', '二十一期', '二十二期', '二十三期', '二十四期', '二十五期', '二十六期', '二十七期', '二十八期', '二十九期', '三十期'],
      tableLoading: false,
      currentTenantData: '',
      currentRowData: '',
      provinceList: areaJson,
      orginTableTwoList:[],
      // billCycleListSelect:[],//多选
      flowLists: [],// 关联流程
      
      formData: {
        approveState:null,
        guid:null,
        relevance: '', // 关联流程
        tenantGuid: null,
        tenantName: null,
        accountMonth: null,
        organisationGuid: null,
        taskBelongCategory:null,//平台专属任务
        // isPrecise: null, //是否精准考核YN
        isApprove: null, //是否发起审批YN
        discardGuid: null, //待废弃GUID
        taskGuidList: [], //任务包GUID列表
        // billCycle: null, //账单周期
        detailList: [],
        remark:''
      },
      page: {
        "approveState": "Y",
        "flowType": "00016", // 
        "searchKey": "",
        "isDownStreamUsed": "",
        "pageIndex": 1,
        "pageSize": -1
      },
      isOption: [
        { text: '是', value: 'N' },
        { text: '否', value: 'Y' },
      ],
      isUsedOption: [
        { label: '全部', value: '' },
        { label: '已关联', value: 'Y' },
        { label: '未关联', value: 'N' },
      ],
      //需验证的字段合集
      fieldData: [
        { title: '平台考核后金额(元)', fieldName: 'finishMoney', type: 'amount',align:'right' },
        { title: '应发金额(元)', fieldName: 'realMoney', type: 'amount',align:'right' },
        { title: '实发金额(元)', fieldName: 'payMoney', type: 'amount',align:'right' },
        { title: '任务完成金额(元)', fieldName: 'taskSalary', type: 'amount',align:'right' },
        { title: '扣奖总额(元)', fieldName: 'cutTotalMoney', type: 'amount',align:'right' },
        { title: '下发平台', fieldName: 'levyCompanyName', type: 'text',align:'left'},
        { title: '管控总评', fieldName: 'totalManageScore', type: 'score',align:'right' },
        { title: '调整意见', fieldName: 'adjustmentOpinions', type: 'text',align:'left' },
        { title: '时间管理', fieldName: 'timeManageScore', type: 'score',align:'right' },
        { title: '质量管理', fieldName: 'qualityManageScore', type: 'score',align:'right' },
        { title: '客户管理', fieldName: 'customerManageScore', type: 'score',align:'right' },
        { title: '计划管理', fieldName: 'planManageScore', type: 'score',align:'right' },
        { title: '使用频度', fieldName: 'useCountScore', type: 'score',align:'right' },
        { title: '调整意见', fieldName: 'adjustmentOpinions', type: 'text',align:'left' },
        { title: '留存金额(元)', fieldName: 'lastMonthLeftMoney', type: 'amount',align:'right' },
      ],
      operationPage: {
        pageIndex: 1,
        pageSize: -1,
        // searchCode:'A001',
        approveState: 'Y',
        flowType: '00016',
        isUsedQuality: 'N',
        isUsedOperationReport:'N',
        searchKey: null,
        tenantGuid:null,
        flowStaffGuids: [],
      },
      operationTableData:[],//运营报告
      operationReportGuid:null,//运营报告guid
      //流程
      currentRow: '',
      currentRowKey: null,
      srcs: '',
      processInstanceId: '',
      iframeSh: false,
      // 导入
      showImport: false,
      importResult: {
        total: 0,
        ok: 0,
        error: 0,
      },
      num: 0,
      currentContractGuid: null,
      isEdit:false,//是否修改
      actualAmount:0,//合计实际金额
      settlementAmount:0,//合计结算金额
      billCycle:'',//账单周期
    }
  },
  computed: {
    isThirdPartyContractor() {
      try {
        // 可以直接访问到 mixins 中的 data 变量
        const { serviceProviderType } = this.Mixins_tenantDetail.servicerCredential;
        return serviceProviderType === ServiceProviderTypeEnum.THIRD_PARTY_CONTRACTOR;
      } catch (error) {
        console.log(error);
      }
    },
  },
  watch:{
    // 平台专属任务
    // "formData.taskBelongCategory":{
    //   immediate:true,
    //   handler(val){
    //     if(!this.isEdit){
    //       this.formData.tenantGuid=null
    //     }
        
    //     if(val==2){
    //       this.tabList= [{ tabName: '考核一览表' }]
    //     }else {
    //       this.tabList=[{ tabName: '考核一览表' }, { tabName: '任务完成明细' }]
    //     }
       
    // }},
    tenantList:{
      immediate:true,
      handler(val){
        let list=[]
        list =val
        console.log('list',list,this.formData.tenantGuid);
        
       
    }
    }
  },
  filters: {
    billFilter(list) {
      let str='-'
      if(list&&list.length>0){
        str=list.join('、')
      }
      return str
    }
  },
  async created() {
    
    //获取服务商
    this.getServiceTenantList();
    this.getFlowGuid();
    await this.Mixins_getServiceProviderType();
    this.getOperationList(1);
    if(this.$route.query.guid){
      this.isEdit = true;
      this.getPageDetail();
    }
    this.getTenantList();
  },
  methods: {
    taskBelongCategoryChange(val) {
      // 切换了是否平台专属任务 清空所有的字段
      this.emptyData();

      this.formData.taskBelongCategory = val;


      if(!this.isEdit){
        this.formData.tenantGuid=null
      }
      
      if(val==2){
        this.tabList= [{ tabName: '考核一览表' }]
      }else {
        this.tabList=[{ tabName: '考核一览表' }, { tabName: '任务完成明细' }]
      }
      
    },
    // 选择流程  
    focusRelevance() {
      let that = this;
      
      that.dialogFormVisible = true;
    },
    // 选择流程
    selectProcess() {
      let { currentRow } = this;
      // console.log(currentRow)
      // 关联流程后显示发起人 + 药企简称 + 月份 + 应付金额
      if (!currentRow['guid']) return this.$message.error('请关联流程');
      //运营报告唯一guid
      this.operationReportGuid = currentRow['guid'];
      this.formData.relevance = currentRow['staffName'] + ' _ ' + currentRow['bizTenantName'] + ' _ ' + currentRow['accountMonthName'] + (currentRow['currentPayAmount'] ? (' _ ' + this.formatMoney(currentRow['currentPayAmount']) + '(元)') : '');
      this.dialogFormVisible = false;
      this.billCycle=currentRow['billCycleList']?currentRow['billCycleList'].join('、'):'-'
      // this.clearHedge() // 清空关联的金额对冲流程
      // 获取单据明细
      // if (this.formData['settleDate']) {
      //     this.getGgenerateDetail();
      // }
    },
    cellClass(row) {
      if (row.columnIndex === 0) {
          return 'disabledCheck';
      }
    },
    handleSelectFlow(selection, row) {
      this.$refs.multipleTable1.clearSelection();
      if (selection.length == 0) {
          return;
      }
      if (row) {
          this.currentRow = row;
          this.currentRowKey = row.guid;
          this.$refs.multipleTable1.toggleRowSelection(row, true);
      }
    },
     //获取运营报告数据
     getOperationList(type) {
      let self = this;
      let userInfo = JSON.parse(localStorage.userInfo);
      if (type == 1) {
        self.operationPage.pageIndex = 1;
      }
      // self.operationPage.currentServiceTenantGuid = localStorage.guid;
      self.operationPage.tenantGuid = self.formData.tenantGuid;
      self.operationPage.flowStaffGuids = [userInfo.staffGuid];
      self.operationPage.isChangeService = 'N'
      if (this.isThirdPartyContractor && this.formData.taskBelongCategory == 1) {
        self.operationPage.isChangeService = 'Y'
        self.operationPage.flowStaffGuids = null
      }
      if (this.isThirdPartyContractor) {
        self.operationPage.tenantGuid = null
        self.operationPage.isUsedOperationReport = null
        self.operationPage.serviceTenantGuid = self.formData.tenantGuid;
      }
       
      self.api.postJson(`/${serverConfig.msSalesPerformService}/upstream/list`, self.operationPage).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.operationTableData = res.data.data.records || [];
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //清空运营报告条件查询
    emptyOperationSearch() {
      // this.operationPage.isUsed = null;
      this.operationPage.searchKey = null;
      this.getOperationList(1);
    },
    //  获取关联流程列表数据
    getFlowList(flag = false, callback) {
      if (flag) {
          this.page.pageIndex = 1;
          this.flowLists = [];
      }
      let postData = {
          ...this.page,
          approveState:'Y',
          listType:1,
          staffGuid:JSON.parse(localStorage.userInfo).staffGuid
      }
      this.api.postJson(`/${serverConfig.msSalesPerformService}/upstream/list`, postData).then((res) => {
          let { code, data } = res.data;
          if (code == serverConfig.REQUIRE_SUCCESS_CODE) {
              this.flowLists = (data && data.records) ? data.records : [];
              // console.log(this.flowLists)
              if (callback) callback();
          } else {
              this.$message.error(res.data.msg);
          }
      });
    },
    // 清空条件搜索,重新获取流程列表数据
    empty() {
        this.page = {
            "approveState": "Y",
            "flowType": "00016", // 
            "searchKey": "",
            "isDownStreamUsed": "",
            "pageIndex": 1,
            "pageSize": -1
        };
        this.getFlowList();
    },
    //  勾选关联流程数据
    flowListsChange(row) {
      this.$refs.multipleTable1.clearSelection();
      row.flag = !row.flag;
      this.$refs.multipleTable1.toggleRowSelection(row, row.flag);
      this.currentRowKey = row.guid;
      this.currentRow = row;
    },
    formatMoney(num) {
      // 将数字转换为字符串并保留两位小数
      num = num.toFixed(2);

      // 将字符串按小数点分割成整数部分和小数部分
      var parts = num.toString().split(".");

      // 将整数部分每三位加一个逗号
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      // 将整数部分和小数部分拼接起来
      return parts.join(".");
    },
    getSumAmount(list, type) {
      let sum = 0;
      if (type == 1) {
        list.forEach((item) => {
          sum += Math.round(item.finishMoney * 100) / 100 ;
        });
      }
      if (type == 2) {
        list.forEach((item) => {
        //  sum += item.realMoney;
          sum += Math.round(item.realMoney * 100) / 100 ;
        });
      }
      if (type == 3) {
        list.forEach((item) => {
          sum += Math.round(item.taskSalary * 100) / 100 ;
          //sum += item.taskSalary;
        });
      }
      if(type==4){
        list.forEach(item => {
          sum += Math.round(item.payMoney * 100) / 100 ;
         // sum += item.payMoney;
        })
      }
      return sum;
    },
    getTip() {
      if (!this.formData.taskBelongCategory) {
        this.$message.error('请先选择是否平台专属任务');
        return false;
      }
      if (!this.formData.tenantGuid) {
        this.$message.error('请先选择药企');
        return false;
      }
      if (!this.formData.organisationGuid) {
        this.$message.error('请选择组织');
        return false;
      }
      if (!this.formData.planYear) {
        this.$message.error('请选择年度');
        return false;
      }
      return true;
    },
    searchData() {
      if (!this.formData.taskBelongCategory) {
        this.$message.error('请先选择是否平台专属任务');
        return false;
      }
      if (!this.formData.tenantGuid) {
        this.$message.error('请先选择药企');
        return ;
      }
      if (this.formData.taskBelongCategory!=2 && !this.formData.organisationGuid) {
        this.$message.error('请选择组织');
        return ;
      }
      if (this.formData.taskBelongCategory!=2 &&!this.formData.accountMonth) {
        this.$message.error('请选择核算月');
        return ;
      }
      if (!this.operationReportGuid) {
        this.$message.error('请选择关联的运营报告');
        return ;
      }
      // if (!this.formData.isPrecise) {
      //   this.$message.error('请选择是否精准考核');
      //   return ;
      // }
      // if (this.formData.isPrecise == 'Y' && !this.formData.billCycle) {
      //   this.$message.error('请选择账单周期');
      //   return ;
      // }
      //  if (this.formData.isPrecise == 'N' && !this.formData.taskGuidList.length) {
      //   this.$message.error('请选择任务包标题');
      //   return ;
      // }
      this.searchDataOne();
      if(this.formData.taskBelongCategory!=2)this.searchDataTwo();
      // if(this.currentTabIndex == 0){
        
      // }else{
        
      //   // this.$nextTick(() => { //在数据加载完，重新渲染表格
      //   //   this.$refs['tableTwo'].doLayout();
      //   // })
      // }
      // this.searchDataOne();
      // this.searchDataTwo();
    },
    //查询数据
    searchDataOne() {
      let self = this;
      let query = {
        serviceTenantGuid:localStorage.guid,
        pageIndex: 1,
        pageSize: -1,
        taskBelongCategory: self.formData.taskBelongCategory,
        tenantGuid: self.formData.tenantGuid,
        organisationGuid: self.formData.organisationGuid,
        // billCycle: self.formData.billCycle == '全部' ? null : self.formData.billCycle,
        // isPrecise: self.formData.isPrecise,
        // taskGuidList: self.formData.taskGuidList,
        accountMonth: self.formData.accountMonth,
        operationReportGuid:self.operationReportGuid,
        buildType:1,
        deductType:1,
        // billCycleList:self.billCycleListSelect
      };
      query.accountMonth = query.accountMonth ? query.accountMonth.replace('-','') : null;
      self.fullscreenLoading = true;
      self.api
        .postJson(`/${serverConfig.msSalesPerformService}/quality-assessment/data/add/get-detail-tab1`, query)
        .then((res) => {
          self.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.formData.detailList = res.data.data || [];
            self.$nextTick(() => { //在数据加载完，重新渲染表格
              self.$refs['tableOne'].doLayout();
            })
          } else {
            self.$message.error(res.data.msg);
          }
        }).catch(()=>{
          self.fullscreenLoading = false;
        });
    },
    searchDataTwo() {
      let self = this;
      let query = {
        serviceTenantGuid:localStorage.guid,
        pageIndex: 1,
        pageSize: -1,
        tenantGuid: self.formData.tenantGuid,
        organisationGuid: self.formData.organisationGuid,
        // billCycle: self.formData.billCycle == '全部' ? null : self.formData.billCycle,
        // isPrecise: self.formData.isPrecise,
        // taskGuidList: self.formData.taskGuidList,
        accountMonth: self.formData.accountMonth,
        operationReportGuid:self.operationReportGuid,
        buildType:1,
        // billCycleList:self.formData.isPrecise == 'Y' ? [] : self.billCycleListSelect 
      };
      query.accountMonth = query.accountMonth ? query.accountMonth.replace('-','') : null;
      self.fullscreenLoading = true;
      self.api
        .postJson(`/${serverConfig.msSalesPerformService}/quality-assessment/data/add/get-detail-tab2`, query)
        .then((res) => {
          self.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tableTwoList = res.data.data || [];
            self.actualAmount = 0 ;//实际金额合计
            self.settlementAmount = 0 ;//结算金额合计
            self.orginTableTwoList = res.data.data ? JSON.parse(JSON.stringify(res.data.data)) : [];
            if(self.tableTwoList && self.tableTwoList.length > 0){
              self.tableTwoList.forEach(i=>{
                i.taskContentName = '-';
                i.taskContentGuid = '-';
                i.rate = 0;
                self.actualAmount = self.actualAmount + i.taskMoney;
                self.settlementAmount = self.settlementAmount + i.realMoney;
                if(i.taskDetailList && i.taskDetailList.length > 0){
                  i.taskDetailList.forEach(j=>{
                    j.staffName = '-';
                    j.staffGuid = null;
                    j.realMoney = '-';
                    j.isOverMoney = '-';
                  })
                }
              })
              let obj = {
                guid: "9999999999999999999",
                isOverMoney: self.settlementAmount > self.actualAmount ? '超额结算' : '未超额结算',
                rate: '-',
                realMoney: self.settlementAmount,
                staffGuid: "-",
                staffName: "合计",
                taskContentGuid: "-",
                taskContentName: "-",
                taskMoney:self.actualAmount,
                taskDetailList:null
              }
              self.tableTwoList.push(obj);
            }
          } else {
            self.$message.error(res.data.msg);
          }
        }).catch(()=>{
          self.fullscreenLoading = false;
        });;
    },
    emptyData() {
      // formData:
      this.formData.taskBelongCategory = null;
      this.formData.tenantGuid = null;
      this.formData.tenantName = null;
      this.formData.accountMonth = null;
      this.formData.organisationGuid = null;
      this.formData.relevance = '';
      this.billCycle=''
      // this.formData.isPrecise = null;
      // this.formData.taskGuidList = [];
      // this.formData.billCycle = null;
      this.$refs.multipleTable1?.clearSelection();
    },
    //表格1
    searchDataOneDetail(){
      let self = this;
      self.api
        .get(`/${serverConfig.msSalesPerformService}/quality-assessment/data/detail/get-detail-tab1?guid=${this.$route.query.guid}`)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.formData.detailList = res.data.data;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //表格2
    searchDataTwoDetail(){
      let self = this;
      self.api
        .get(`/${serverConfig.msSalesPerformService}/quality-assessment/data/detail/get-detail-tab2?guid=${this.$route.query.guid}`)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tableTwoList = res.data.data || [];
            self.actualAmount = 0 ;//实际金额合计
            self.settlementAmount = 0 ;//结算金额合计
            self.orginTableTwoList = res.data.data ? JSON.parse(JSON.stringify(res.data.data)) : [];
            if(self.tableTwoList && self.tableTwoList.length > 0){
              self.tableTwoList.forEach(i=>{
                i.taskContentName = '-';
                i.taskContentGuid = '-';
                i.rate = 0;
                self.actualAmount = self.actualAmount + i.taskMoney;
                self.settlementAmount = self.settlementAmount + i.realMoney;
                if(i.taskDetailList && i.taskDetailList.length > 0){
                  i.taskDetailList.forEach(j=>{
                    j.staffName = '-';
                    j.staffGuid = null;
                    j.realMoney = '-';
                    j.isOverMoney = '-';
                  })
                }
              })
              let obj = {
                guid: "9999999999999999999",
                isOverMoney: self.settlementAmount > self.actualAmount ? '超额结算' : '未超额结算',
                rate: '-',
                realMoney: self.settlementAmount,
                staffGuid: "-",
                staffName: "合计",
                taskContentGuid: "-",
                taskContentName: "-",
                taskMoney:self.actualAmount,
                taskDetailList:null
              }
              self.tableTwoList.push(obj);
              self.$nextTick(() => { //在数据加载完，重新渲染表格
                self.$refs['tableTwo'].doLayout();
              })
              console.log(self.tableTwoList,'333')
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    // 点击tab
    tabChange(item, index) {
      this.currentTabIndex = index;
      if(index == 1 && !this.isEdit){
        this.searchDataTwo();
      }
    },
    getPositionName(list){
      let name = '-';
      let nameArr = [];
      let arr = list ? JSON.parse(list) : [];
      if(arr && arr.length > 0){
        arr.forEach(i=>{
          nameArr.push(i.positionName);
        })
      }
      return arr.length > 0 ?  nameArr.join(',') : '-'
    },
    //获取药企
    getTenantList() {
      let self = this;
      let relType = null;
      if (this.isThirdPartyContractor) {
        relType = '123'; // 写死
      }
      let query = {
        isService: true,
        tenantGuid: localStorage.guid,
        relType,
      };
      self.api
        .get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`, query)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tenantList = res.data.data;
            if (this.isThirdPartyContractor) {
              this.formData.taskBelongCategory = 1;
              this.formData.tenantGuid = this.Mixins_tenantDetail.guid;
              this.formData.tenantName = this.Mixins_tenantDetail.tenantName;
              this.getOrganisationList();
              this.getOperationList(1);
            }

            if (self.tenantList && self.tenantList.length > 0 && !this.$route.query.tenantGuid) {
              if(!self.formData.tenantGuid){
                //self.formData.tenantGuid = self.tenantList[0].sendTenantGuid;
                //self.formData.tenantName = self.tenantList[0].sendTenantName;
              }
              
              // self.getOrganisationList(self.formData.tenantGuid);
            }
            
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //获取服务商
    getServiceTenantList() {
      let self = this;
      self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/select-service-tenants`).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.serviceTenantList = res.data.data || [];
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    tenantChange(val) {
      let flg=this.formData.taskBelongCategory;// 2平台专属
      if (val) {
        if(flg==2){
          this.serviceTenantList.forEach(i=>{
            if(i.guid == val ){
              this.formData.tenantName = i.tenantName;
            }
          })
        }else{
          this.tenantList.forEach(i=>{
          if(i.sendTenantGuid == val ){
            this.formData.tenantName = i.sendTenantName;
          }
        })
        }
        
        this.formData.organisationGuid = null;
        this.formData.accountMonth=null
        this.formData.relevance=''
        this.operationReportGuid=null
        this.operationTableData=[]
        // this.formData.isPrecise = null;
        // this.formData.taskGuidList = [];
        // this.formData.billCycle = null;
        // this.getTaskList();
        this.getCycleData();
        this.getOrganisationList(val);
        this.getOperationList(1)
      }
    },
    //获取组织
    getOrganisationList(v) {
      let self = this;
      self.api
        .get(`/${serverConfig.msPersonnelService}/organisation/get-organisation-dict?tenantGuid=${this.formData.tenantGuid}`)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.organisationList = res.data.data || [];
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    changeOrganisation(val) {
      if (val) {
        this.organisationList.forEach(i=>{
          if(i.value == val ){
            this.formData.organisationName = i.text;
          }
        })
        // this.formData.billCycle = null;
        // this.billCycleListSelect = [];
        // this.getTaskList();
        this.getCycleData();
      }
    },
    //获取任务
    getTaskList() {
      let self = this;
      // if(self.formData.isPrecise !== 'N'){
      //   return
      // }
      if(!self.formData.tenantGuid || !self.formData.organisationGuid || !self.formData.accountMonth){
        // self.$message.error('请先选择信息')
        return
      }
      let query = {
        pageIndex: 1,
        pageSize: -1,
        tenantGuid: self.formData.tenantGuid,
        organisationInfo: self.formData.organisationGuid,
        isService: 'Y',
        payState: '未结算',
        state: ['已派发', '待上传', '待考核', '待结算'],
        accountMonth: self.formData.accountMonth,
      };
      query.accountMonth = query.accountMonth.replace('-','');
      self.api.postJson(`/${serverConfig.msSalesPerformService}/task/data/get-list`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          if (res.data.data && res.data.data.records) {
            self.taskList = res.data.data.records;
          }
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    // changePrecise() {
    //   this.taskList = [];
    //   this.formData.taskGuidList = [];
    //   this.formData.billCycle = null;
    //   this.billCycleListSelect = [];
    //   this.changeAccountMonth();
    // },
    changeAccountMonth() {
      // this.getTaskList();
      this.getCycleData();
    },
    //获取周期
    getCycleData() {
      let self = this;
      if (!this.formData.tenantGuid) {
        // this.$message.error('请选择药企名称!');
        return;
      }
      if (!this.formData.accountMonth) {
        // this.$message.error('请选择核算月!');
        return;
      }
      let accountMonth = JSON.parse(JSON.stringify(this.formData.accountMonth));
      accountMonth = accountMonth.replace('-', '');
      self.api
        .postJson(
          `/${serverConfig.msSalesPerformService}/staff-salary-task/data/get-salary-bill-cycle?accountMonth=${accountMonth}&tenantGuid=${this.formData.tenantGuid}`,
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.billCycleList = res.data.data || [];
            if(self.billCycleList && self.billCycleList.length > 0){
              self.billCycleList.forEach((i,index)=>{
                if(!i){
                  self.billCycleList[index] = '全部';
                }
              })
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    // 金额汇总
    getMoneySummary(row, index) {
      let money = 0;
      this.fieldData.forEach((i) => {
        for (let j in row) {
          if (i.fieldName == j && i.type == 'num') {
            money = money + Number(row[j]);
          }
        }
      });
      this.formData.detailList[index].generalBudget = money;
      return money;
    },

    //获取详情
    getPageDetail() {
      let self = this;
      self.api
        .get(`/${serverConfig.msSalesPerformService}/quality-assessment/data/detail/get-by-guid?guid=${this.$route.query.guid}`)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let data = res.data.data;
            self.formData = {
              approveState:data.approveState,
              serviceTenantGuid:data.serviceTenantGuid,
              guid:data.guid,
              tenantGuid: data.tenantGuid,
              tenantName: data.tenantName,
              accountMonth: data.accountMonth ? data.accountMonth.substr(0,4) + '-' + data.accountMonth.substr(4,2) : null,
              organisationGuid: data.organisationGuid,
              organisationName:data.organisationName,
              // isPrecise: data.isPrecise, //是否精准考核YN
              isApprove: data.isApprove, //是否发起审批YN
              discardGuid: data.discardGuid, //待废弃GUID
              // taskGuidList: data.taskGuidList ? JSON.parse(data.taskGuidList) : [], //任务包GUID列表
              // billCycle: data.isPrecise == 'Y' && data.billCycle ? data.billCycle : '全部',//账单周期
              detailList:[],
              remark:data.remark || '',
              taskBelongCategory:data.taskBelongCategory,
            };
            self.operationReportGuid=data.operationReportGuid
            // if(data.isPrecise == 'N' && data.billCycle){
            //   this.billCycleListSelect = data.billCycle.split(',');
            // }
            console.log('66',self.formData.tenantGuid);
            
            this.$forceUpdate()
            self.getOrganisationList();
            self.getCycleData();
            // self.getTaskList();
            self.searchDataOneDetail();
            if(self.formData.taskBelongCategory!=2)self.searchDataTwoDetail();
            self.getDetail()

          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //获取运营报告详情
    getDetail() {
      let self = this;
      if(!this.operationReportGuid) return
      self.api
        .get(`/${serverConfig.msSalesPerformService}/upstream/operation-report/detail?guid=${this.operationReportGuid}`)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let data = res.data.data;
            
            this.formData.relevance = data['approveVO']['staffName'] + ' _ ' + data['tenantName'] + ' _ ' + data['accountMonth'] + (data['currentPayAmount'] ? (' _ ' + this.formatMoney(data['currentPayAmount']) + '(元)') : '');
            this.billCycle=data['billCycleList']?data['billCycleList'].join('、'):'-'
            console.log(data);
            this.$forceUpdate()
            
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    checkForm(){
      if (!this.formData.taskBelongCategory) {
        this.$message.error('是否平台专属任务不能为空');
        return false;
      }
      if (!this.formData.relevance) {
        this.$message.error('关联流程不能为空')
        return false;
      }
      if (!this.formData.tenantGuid) {
        this.$message.error('企业名称不能为空!');
        return false;
      }
      if (this.formData.taskBelongCategory!=2&&!this.formData.organisationGuid) {
        this.$message.error('组织名称不能为空!');
        return false;
      }
      if (this.formData.taskBelongCategory!=2&&!this.formData.accountMonth) {
        this.$message.error('核算月不能为空!');
        return false;
      }
      // if (!this.formData.isPrecise) {
      //   this.$message.error('是否精准考核不能为空!');
      //   return false;
      // }
      // if (!this.formData.billCycle) {
      //   this.$message.error('账单周期不能为空!');
      //   return false;
      // }
      if (!this.formData.detailList.length) {
        this.$message.error('明细数据不能为空!');
        return false;
      }
      return true;
    },
    checkDraftForm() {
      if (this.formData.taskBelongCategory == 2) {
        if (!this.formData.tenantGuid) {
          this.$message.error('药企名称不能为空');
          return false;
        }
        if (!this.formData.relevance) {
          this.$message.error('关联流程不能为空')
          return false;
        }
      }
      if (this.formData.taskBelongCategory == 1) {
        if (!this.formData.tenantGuid) {
          this.$message.error('企业名称不能为空!');
          return false;
        }
        if (!this.formData.organisationGuid) {
          this.$message.error('组织名称不能为空!');
          return false;
        }
        if (!this.formData.relevance) {
          this.$message.error('关联流程不能为空')
          return false;
        }
        return true;
      }
    },
    submitData(type) {
      if (!this.formData.taskBelongCategory) {
        this.$message.error('是否平台专属任务不能为空');
        return;
      }
      if (type == 1 && !this.checkForm()) {
        return;
      }
      if (type == 0 && !this.checkDraftForm()) {
        return;
      }
      let userinfo = JSON.parse(localStorage.userInfo);
      let form = JSON.parse(JSON.stringify(this.formData));
      form.staffGuid = userinfo.staffGuid;
      form.operationReportGuid = this.operationReportGuid;
      form.staffName = userinfo.staffName;
      // form.organisationName = userinfo.organisationName;
      form.serviceTenantGuid = localStorage.guid;
      let reqUrl;
      form.isApprove = type == 1 ? 'Y' : 'N';//是否发起审批
      //判断周期
      // if(form.isPrecise == 'N' && this.billCycleListSelect.length > 0){
      //   form.billCycle = this.billCycleListSelect.join(',');
      // }
      if (this.$route.query.toType == 3) {//重新提交
        form.guid = null;
        form.discardContractGuid = this.$route.query.guid;
      }
      if (this.formData.guid) {
        reqUrl = `/quality-assessment/data/update`;
      } else {
        reqUrl = `/quality-assessment/data/add`;
      }
      // form.billCycle = form.billCycle == '全部' ? null : form.billCycle;
      form.accountMonth = form.accountMonth ? form.accountMonth.replace('-','') : '';
      this.fullscreenLoading = true;
      this.api
        .postJson(`/${serverConfig.msSalesPerformService}${reqUrl}`, form)
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.$message({
              message: '提交成功',
              type: 'success',
            });
            this.$router.go(-1);
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(() => {
          this.fullscreenLoading = false;
        });
    },
    //下载模板
    downLoadFile() {
      window.open('/市场推广计划导入模板.xlsx');
    },
    //上传文件
    changeFile(file, fileList) {
      let self = this;
      self.fileList = [];
      self.fullscreenLoading = true;
      let formData = new FormData();
      formData.append('taskBelongCategory', this.formData.taskBelongCategory); //传文件
      formData.append('file', file.file); //传文件
      formData.append('oldList', JSON.stringify(this.formData.detailList))
      let importUrl = `/${serverConfig.msSalesPerformService}/quality-assessment/staff-salary`;
      self.api.postFile(importUrl, formData).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let list = res.data.data || [];
          if(list.length > 0 && self.formData.detailList.length > 0){
            self.formData.detailList.forEach(i=>{
              list.forEach(j=>{
                if(i.guid === j.guid){
                  // i.staffName = j.staffName;
                  i.adjustmentOpinions = j.adjustmentOpinions;
                  i.customerManageScore = j.customerManageScore;
                  i.cutTotalMoney = j.cutTotalMoney;
                  i.planManageScore = j.planManageScore;
                  i.qualityManageScore = j.qualityManageScore;
                  i.finishMoney = j.finishMoney;
                  i.timeManageScore = j.timeManageScore;
                  i.totalManageScore = j.totalManageScore;
                  i.useCountScore = j.useCountScore;
                  i.realMoney = j.realMoney;
                  i.levyCompanyGuid = j.levyCompanyGuid ? j.levyCompanyGuid : i.levyCompanyGuid;
                  i.levyCompanyName = j.levyCompanyGuid ? j.levyCompanyName : i.levyCompanyName;
                }
              }) 
            }) 
          }
          // self.formData.detailList = res.data.data;
        } else {
          self.$message({
            type: 'warning',
            message: res.data.msg,
          });
          return false;
        }
      });
    },
    //批量导入
    beforeUpload(file) {
      let filename = file.name;
      let arr = filename.split('.');
      let length=arr.length-1;
      if (arr[length] !== 'xls' && arr[length] !== 'xlsx' && arr[length] !== 'xlsm') {
        this.$message.error('上传文件只能是 excel/xls 格式!');
        return false;
      }
      return arr;
    },
    //下载失败数据
    downFailData() {
      let self = this;
      self.api
        .postJsonD(
          `/${serverConfig.msSalesPerformService}/marketing-plan/export-error-data?tenantGuid=${this.formData.tenantGuid}&organisationGuid=${this.formData.organisationGuid}`,
        )
        .then((res) => {
          if (res.data) {
            let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            let fileName = '市场推广计划';
            let objectUrl = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.download = fileName;
            link.href = objectUrl;
            link.click();
          } else {
            self.$message.error(res.msg || '下载失败，请联系管理员！');
          }
        });
    },
    //导出1
    exportTable(type) {
      this.exportSettingLoading = true;
      this.api
        .postJson(
          `/${serverConfig.msSalesPerformService}/quality-assessment/data/add/export-tab1`,this.formData.detailList
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.reportJx(res.data.data.colNames, res.data.data.datas, res.data.data.sheetName, res.data.data.fileNam);
          } else {
            this.$message.error(res.data.msg);
            this.exportSettingLoading = false;
          }
        });
    },
    // todo重新结算方法
    recalculate() {
      if (!this.selectData.length) {
         this.$message({
          message: '请勾选',
          type: 'warning'
        });
        return;
      }
      let param = {
        serviceTenantGuid: this.formData.serviceTenantGuid,
        guidList:this.selectData.map(item=>item.guid)
      }
      this.api.postJson(`/${serverConfig.msSalesPerformService}/quality-assessment/data/reset-task-type`,param).then(res=>{
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.$message({
              message: '重算成功',
              type: 'success'
            });
          } else {
            this.$message.error(res.data.msg);
          }
      })
    },
    // todo勾选的钩子
    handleSelectionChange(val) {
      this.selectData = val;
    },
    //导出2
    exportTableTwo(type) {
      let self = this;
      this.exportSettingLoading = true;
      if (this.$route.query.guid) {
        this.api
          .get(
            `/${serverConfig.msSalesPerformService}/quality-assessment/data/detail/export-tab2?guid=${this.$route.query.guid}`)
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              this.reportJx(res.data.data.colNames, res.data.data.datas, res.data.data.sheetName, res.data.data.fileNam);
            } else {
              this.$message.error(res.data.msg);
              this.exportSettingLoading = false;
            }
          });

      }else{
        let query = {
          serviceTenantGuid:localStorage.guid,
          pageIndex: 1,
          pageSize: -1,
          tenantGuid: self.formData.tenantGuid,
          organisationGuid: self.formData.organisationGuid,
          // billCycle: self.formData.billCycle == '全部' ? null : self.formData.billCycle,
          // isPrecise: self.formData.isPrecise,
          // taskGuidList: self.formData.taskGuidList,
          accountMonth: self.formData.accountMonth,
          buildType:1,
          operationReportGuid:self.operationReportGuid,
          // billCycleList:self.formData.isPrecise == 'Y' ? [] : self.billCycleListSelect 
        };
        query.accountMonth = query.accountMonth.replace('-','');
        this.api
          .postJson(
            `/${serverConfig.msSalesPerformService}/quality-assessment/data/add/export-tab2`,query)
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              this.reportJx(res.data.data.colNames, res.data.data.datas, res.data.data.sheetName, res.data.data.fileNam);
            } else {
              this.$message.error(res.data.msg);
              this.exportSettingLoading = false;
            }
          });

      }
     
    },
    reportJx(colNames, datas, sheetName, fileNam) {
      let self = this;
      // let fileName = self.formData.tenantName + '_' + self.formData.organisationName + '_' + self.formData.accountMonth + '_' + (self.formData.isPrecise == 'Y' ? '精准考核' : '非精准考核');
      let fileName = self.formData.tenantName + '_' + self.formData.organisationName + '_' + self.formData.accountMonth;
      self.api
        .postJsonD(`/${serverConfig.msCommonAdminCloudService}/excel/export`, {
          colNames: colNames,
          datas: datas,
          sheetName: sheetName,
          fileNam: fileName,
        })
        .then((res) => {
          self.exportSettingLoading = false;
          self.showExportHead = false;
          let blob = new Blob([res.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });
          let objectUrl = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.download = fileName;
          link.href = objectUrl;
          link.click();
        });
    },
    //获取流程Guid
    getFlowGuid() {
      let self = this;
      let userInfo = JSON.parse(localStorage.userInfo);
      let req = {
        tenantGuid: localStorage.guid,
        flowType: this.flowType,
        staffGuid: userInfo.staffGuid,
      };
      self.api
        .postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/get-camunda-deployment-id`, req)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (res.data.data) {
              self.iframeSh = true;
              self.srcs =
                bpmnroute + '/iframeBpmn?camundaDeploymentId=' + res.data.data + '&token=' + localStorage.token;
              console.log(self.srcs);
            } else {
              self.$message.error(messageConfig.FLOW_NO_ID);
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
  },
};
</script>
<style lang="less" scoped>
.search-btn-box{
  justify-content: flex-start
}
/deep/ .table_header {
  background-color: #F0F0F0 !important;
  padding: 10px 0;
  color: #323233;
} 
/deep/ .has-gutter {
	.el-checkbox__inner {
		display:none !important;
	}	
}
.remark {
  background-color: #fff;
  padding-bottom: 8px;
  width: 780px;
}
.remark p {
  margin: 8px 0;
}
.contract-information-page {
  overflow: auto;
}
.contract-base-box {
  padding: 12px 16px 0px 16px;
  margin: 4px 0;
  background: #fff;
}
.contract-base-name {
  font-size: 16px;
  color: #212121;
  text-align: left;
  margin: 8px 0 20px 0;
}
.contract-base-box .el-col-20,
.contract-base-box .el-col-14,
.contract-base-box .el-col-4,
.contract-base-box .el-col-3,
.contract-base-box .el-col-5,
.contract-base-box .el-col-6,
.contract-base-box .el-col-7
{
  /* min-height: 37px; */
  display: flex;
  /* align-items: center; */
  margin-bottom: 16px;
  padding-right: 20px;
  box-sizing: border-box;
}
.contract-base-title {
  flex-shrink: 0;
  width: 80px;
  line-height: 36px;
  text-align: end;
  margin-right: 3px;
  font-size: 14px;
}
.contract-base-flow {
  flex-shrink: 0;
  line-height: 36px;
  text-align: start;
  font-size: 14px;
  display: flex;
  flex-wrap: nowrap;
  padding-right: 22px;
}
.search-btn{
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.el-col-24{
  padding-bottom: 10px;
}
.content-main-box2 {
  height: 55vh;
  overflow-x: hidden;

  .search-area {
      padding: 16px 0px;
  }

  .el-table {
      border-left: 1px solid #D8D8D8;
      border-right: 1px solid #D8D8D8;
      border-bottom: 1px solid #D8D8D8;
  }
}
.contract-base-content {
  width: 310px;
  text-align: left;
  line-height: 36px;
}
/deep/.el-radio-group {
  padding-top: 5px !important;
}
/* 添加银行 */
.add-bank-box {
  color: #4fa1a4;
  margin-left: 15px;
  line-height: 36px;
}
.add-bank-box span {
  cursor: pointer;
}
.iframe-sty {
  width: 100%;
  height: 500px;
  border: none;
  /* background:grey; */
}
.btn-import{
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
/* 导入 */
.importClass .secondStep {
  margin-top: 50px;
  height: 200px;
}

.importClass .secondStep .line1 {
  font-size: 20px;
}

.importClass .secondStep .line2 {
  font-size: 16px;
}

.importClass .secondStep .line2 span {
  color: #4fa1a4;
}

.importClass .secondStep .line3 {
  text-decoration: underline;
  cursor: pointer;
}
.ipt-sty {
  margin-right: 10px;
}
.content-main-box /deep/ .el-input__inner {
  height: 30px;
  line-height: 30px;
}
.el-col-7 ,.el-col-3 ,.el-col-8{
  display: flex;
  margin-bottom: 10px;
}
.input-warning /deep/ .el-input__inner {
  border: 1px solid red;
}
.select-task {
  color: #4fa1a4;
  text-decoration: underline;
  cursor: pointer;
}
.ipt-sty{
  flex: 1!important;
}
.total-tip span{
  color: #FF5F1F;;
}
</style>
